import React from 'react';
import { FormSeller } from './FormSeller';
import { DeleteSeller } from './DeleteSeller';
import { Dialog } from "primereact/dialog";
import { Button } from 'reactstrap'


export const ModalSeller = (props) => {

    const {
        modal, toggle, modalTitle, method, loading,
        name, paternal_surname, maternal_surname, number_phone, email, handleInputChange,
        saveCreate, saveUpdate, saveDelete, validaciones, closeModalSeller
    } = props;


    const dialogClassName =
        method === "delete"
            ? "medium-dialog delete-method"
            : "medium-dialog-seller";

    return (
        <Dialog
            visible={modal}
            onHide={closeModalSeller}
            modal
            closable={true}
            dismissableMask={false}
            className={dialogClassName}
            header={modalTitle}
            blockScroll={true}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
                content: { style: { paddingLeft: "1px" } }
            }}
            footer={
                <>
                    {
                        method === "create" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveCreate}
                            disabled={loading}
                        >
                            {loading ? "Guardando" ?? "--" : "Guardar" ?? "---"}
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveUpdate}
                            disabled={loading}
                        >
                            {loading ? "Actualizar" ?? "--" : "Actualizar" ?? "---"}
                        </Button>
                    }
                    {
                        (method !== "update" && method !== "create") && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveDelete}
                            disabled={loading}
                        >
                            {loading ? "Eliminando..." : "Sí, eliminar"}
                        </Button>
                    }
                    <Button
                        size="sm"
                        color="danger"
                        type="button"
                        onClick={closeModalSeller}
                        disabled={loading}
                    >
                        {"Cancelar" ?? "---"}
                    </Button>
                </>
            }
        >
            {
                method === "create" ?
                    <FormSeller
                        button="Crear"
                        {...{ toggle, loading, name, paternal_surname, maternal_surname, number_phone, email, handleInputChange, validaciones, closeModalSeller, methodAction: saveCreate }}
                    />
                    : (method === "update") ?
                        <FormSeller
                            button="Actualizar vendedor"
                            {...{ toggle, loading, name, paternal_surname, maternal_surname, number_phone, email, handleInputChange, validaciones, closeModalSeller, methodAction: saveUpdate }}
                        />
                        : <DeleteSeller
                            {...{ closeModalSeller, loading, name, saveDelete }}
                        />
            }
        </Dialog>
    )
}
